import { axios } from '@/utils/request'

const api = {
    getProductList: '/5d3ba95bb2f18',
    getMemberLits: '/5d3ba87da999f',
    getIncomeList: '/5d3becb40645b',
    getCashWithdrawal: '/5d3e619017fe1',
    getPartnerMemberList: '/5d3bbede891ba'
}

export default {
    // 获取商品列表
    getProductList: () => {
        return axios({
            url: api.getProductList,
            method: 'get',
            params: {}
        })
    },
    // 支付链接
    getPayLink: ({ product_type, product_number, main_id, sub_id }) => {
        return new Promise((resolve, reject) => {
            const link = `https://cloudmanage.nianchu.net/api/5d3a66da98e8a?product_type=${product_type}&product_number=${product_number}&main_id=${main_id}&sub_id=${sub_id}`
            resolve(link)
        })
    },
    // 获取下级列表
    getMemberList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getMemberLits,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: params.page,
                pageSize: params.size,
                totalCount: res.data.count
            }
        })
    },
    // 获取下级列表
    getPartnerMemberList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getPartnerMemberList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: params.page,
                pageSize: params.size,
                totalCount: res.data.count
            }
        })
    },
    // 获取推广收入明细列表
    getIncomeList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getIncomeList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: params.page,
                pageSize: params.size,
                totalCount: res.data.count
            }
        })
    },
    // 提现
    getCashWithdrawal: ({ money, ali_pay, real_name}) => {
        const parameter = { money, ali_pay, real_name }
        return axios({
            url: api.getCashWithdrawal,
            method: 'get',
            params: parameter
        })
    }
}
